<template>
<div class="bottomnume_right">
  <el-carousel trigger="click" height="64px" indicator-position="none" :autoplay="false" arrow="always" >
    <el-carousel-item v-for="(v, index) in list" :key="index" style="padding: 0 24px;">
      <div class="gift" v-for="item in v" :key="item.id" @click="handleClick(item)">
        <img v-lazy="item.imgUrl" :alt="item.desc" :title="item.desc" />
        <p>{{ isManger ? item.gcents : item.gcoins }}{{ isManger ? '积分' : 'G币'}}</p>
      </div>
    </el-carousel-item>
  </el-carousel>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Dialog from '@/utils/Dialog'

export default {
  name: 'component-room-gift',
  data () {
    return {
      //    礼物列表
      list: []
    }
  },
  mounted () {
    this.getGiftList()
  },
  methods: {
    // 加载礼物
    getGiftList () {
      this.$axios._get('/Room/GiftList', { type: this.isManger ? 'gcents' : 'gcoins' }).then( resp => {
        let list = [], size = 6
        for (let i = 0; i < Math.ceil(resp.length / size); i++) {
          list.push(resp.slice(i * size, (i + 1) * size))
        }
        this.list = list
      })
    },
    handleClick (item) {
      // 若未登录则需先登录再进行登录操作
      if(!this.$isLogin()) {
        Dialog.login()
        return
      }
      // Dialog.gift(item)
      this.$emit('present', item)
    },
  },
  computed: {
    ...mapState({
      authUser: state => state.user.data,
      roomData: state => state.room.data
    }),
    ...mapGetters({
      isManger: 'user/isManger'
    })
  }
}

</script>
<style lang="less" scoped>
.bottomnume_right { position: relative; height: 64px; padding:0px; background: #f7f7f7;
  a { position: absolute; width: 13px; height: 27px; top:17px ; cursor: pointer; line-height: 27px; background: #c4c4c4; text-align: center; overflow: hidden;
      &:hover i { color: #e7735a;}
      i { color: #FFFFFF; font-size: 14px;}
  }
  .spanleft { left: 10px; padding-left: 3px;}
  .spanright {right: 10px; padding-right: 3px;}
  .message { height: 100%; position: absolute; top: 0; background: #F7F7F7;}
  .message:nth-of-type(1) { z-index: 1;}
  .el-carousel__arrow--left { left: 8px !important;}
  .gift { float: left; width: 16%; height: 100%; margin: 0 1px; text-align: center; cursor: pointer;
      > img { width: 50px; height:44px; }
      > p { text-align: center;}
  }
}
</style>
